module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapp"
  }, [(_vm.isCaruselData) ? _c('Slider', {
    attrs: {
      "items": _vm.caruselData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_data = ref.data;
        var info = ref_data.info;
        var upperIndex = ref_data.index;

        return _vm._l((info), function(item, index) {
          return _c('Card', {
            key: index,
            attrs: {
              "item": item
            }
          }, [_vm._t("default", null, {
            "data": {
              item: item,
              index: index,
              upperIndex: upperIndex
            }
          })], 2)
        })
      }
    }], null, true)
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "item": item
      }
    }, [_vm._t("default", null, {
      "data": {
        item: item,
        index: index
      }
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-962b562e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/cardwrapper/MentoringCardWrapper.vue
// module id = 5c86182a02ac72a2e883
// module chunks = 89